import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { Hospital } from 'types/hospital';
import { ProcedureDoctor, ProcedurePackage } from 'types/procedure';
import { SurgerieFormData } from 'types/surgerie';

export type NewSurgerieContextData = {
  validation: string;
  surgerie: SurgerieFormData;
  loadingHospitals: boolean;
  doctors: ProcedureDoctor[];
  hospitals: Hospital[];
  handleChangePackages(packages: ProcedurePackage[]): void;
  handleChange(key: keyof SurgerieFormData, value: any): void;
};

const NewSurgerieContext = createContext<NewSurgerieContextData>({} as NewSurgerieContextData);
export const NewSurgerieProvider = NewSurgerieContext.Provider;
export const NewSurgerieConsumer = NewSurgerieContext.Consumer;

export function useNewSurgerie(): NewSurgerieContextData {
  const context = useContext(NewSurgerieContext);
  return context;
}
